module.exports = __webpack_public_path__ + "5384a326c2ec34dc9c8df652b33a27ff.png";